import { IEventConditionFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { IBuilder, IRow } from '../types';
import { defaultRow } from '../defaults';

export const getMeasureFunction = (
  defaultMeasureFunctions: IBuilder['defaultMeasureFunctions'],
  subjectName: string | null,
) => {
  // By default, we will try to find UNIQUE_USERS
  const uniqueUsersFn = defaultMeasureFunctions.find(
    (measureFunction) => measureFunction.key === 'UNIQUE_USERS',
  );

  if (uniqueUsersFn) {
    return uniqueUsersFn;
  }

  // If UNIQUE_USERS not found and subjectName is provided - try to find
  // a function: Unique ${subjectName}
  if (subjectName) {
    const uniqueSubjectFn = defaultMeasureFunctions.find((measureFunction) => {
      const lowercaseName = measureFunction.name.toLowerCase();

      return (
        lowercaseName.includes('unique') &&
        lowercaseName.includes(subjectName.toLowerCase())
      );
    });

    if (uniqueSubjectFn) {
      return uniqueSubjectFn;
    }
  }

  // As a fallback, return first element from the list
  return defaultMeasureFunctions[0];
};

export const generateMeasureRowsFromEventConditions = (
  eventConditionsArray: Array<IEventConditionFieldsFragment[]>,
  defaultMeasureFunctions: IBuilder['defaultMeasureFunctions'],
  subjectName: string | null,
): IRow[] => {
  return eventConditionsArray.map((eventConditions) => ({
    ...defaultRow(),
    fn: getMeasureFunction(defaultMeasureFunctions, subjectName),
    eventConditions,
  }));
};
